import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

/**
 * Layout: Content + Stapelende afbeeldingen (FAQ)
 * Slug: content_stacking_images_faq
 */

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.content_stacking_images_faq-layout').forEach((layout) => {
		const el = layout.querySelector('.content_stacking_images_faq-swiper');
		const items = layout.querySelectorAll('.faq-item');

		if (!items.length) return;

		let swiper = null;

		if (el && el.dataset.init !== '1') {
			el.dataset.init = '1';

			swiper = new Swiper(el, {
				effect: 'cards',
				grabCursor: false,
				allowTouchMove: false,
				cardsEffect: {
					perSlideOffset: 8,
					perSlideRotate: 3,
					slideShadows: false
				},
				on: {
					slideChange() {
						setActive(this.activeIndex);
					}
				}
			});
		}

		function setActive(idx) {
			items.forEach((item) => {
				const active = Number(item.dataset.slide) === idx;

				item.classList.toggle('active', active);

				const t = item.querySelector('.faq-title');
				const c = item.querySelector('.faq-content');

				if (t) t.setAttribute('aria-expanded', active ? 'true' : 'false');
				if (c) c.setAttribute('aria-hidden', active ? 'false' : 'true');
			});
		}

		items.forEach((item) => {
			const toggle = item.querySelector('.faq-title');

			if (!toggle) return;

			toggle.addEventListener('click', () => {
				const idx = Number(item.dataset.slide);

				if (Number.isNaN(idx)) return;

				setActive(idx);

				if (swiper) swiper.slideTo(idx);
			});
		});

		const initial = [...items].findIndex((i) => i.classList.contains('active'));
		const startIdx = initial >= 0 ? initial : 0;

		setActive(startIdx);

		if (swiper) swiper.slideTo(startIdx, 0);
	});
});
